import { Link, Outlet, useLocation, useNavigate } from "react-router-dom";
import { APP_NAME, LANDING_PAGE_URL, LOGO_CDN_URL } from "../constants/constants";
import { useDispatch } from "react-redux";
import { setIntendedPath } from "../redux-stores/slices/layoutSlice";
import MobileView from "./MobileView/MobileView";
import { textToTitleCase } from "../utils/helpers";
import { useSelector } from "react-redux";
import { RootState } from "../redux-stores/store";

const PublicLayout: React.FC = () => {
    const location = useLocation();
    const dispatch = useDispatch();

    const {bg_white} = useSelector((state: RootState) => state.layout);

    const updateIntendedURL = () => {
        dispatch(setIntendedPath(location.pathname + location.search));
    }

    return (
        <MobileView>
            <div className="container-fluid px-0">
                <div className="px-4 py-2 public-header bg-white w-100 d-flex align-items-center justify-content-between border-bottom" style={{ height: '75px', }}>
                    <Link to='/'><img src={LOGO_CDN_URL} height={35} /></Link>
                    <Link to='/register' onClickCapture={updateIntendedURL} className="btn btn-sm btn-primary rounded-sm">Join Now</Link>
                </div>
                <div className={`content ${bg_white ? 'bg-white m-0 p-2' : ''}`}>
                    <Outlet />
                </div>
                <div className="d-flex justify-content-between align-items-center px-4 pb-3">
                    <div className="text-gray-900">
                        <span className="text-muted fw-semibold me-1">2025©</span>
                        <Link to="/" className="text-gray-800 text-hover-primary">
                            {textToTitleCase(APP_NAME)}
                        </Link>
                    </div>
                    <div className="d-flex">

                        <Link to={LANDING_PAGE_URL} className="menu-link px-2">
                            About
                        </Link>
                        <a
                            href="https://api.whatsapp.com/send?phone=+919266391960&text=Hi, I need help."
                            target="_blank"
                            rel="noopener noreferrer"
                            className="menu-link px-2"
                        >
                            Support
                        </a>
                        <a target="_blank"
                            rel="noopener noreferrer" href={LANDING_PAGE_URL + "/legal/terms.html"} className="menu-link px-2">
                            Terms
                        </a>
                    </div>

                </div>
            </div>
        </MobileView>
    )
}

export default PublicLayout;